angular.module('webcomm').directive('showFocus', ['$timeout', function($timeout) {
     function link(scope, element, attrs) {
        scope.$watch(attrs.showFocus, 
          function (newValue) {
              $timeout(function() {
                  newValue && element[0].focus();
              });
          },true);
    }

    return {
        restrict: 'A',
        link: link
    };
}]);